import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { isManagingAttorney } from "../../../../lib/primaryItemScripts";
import Tag from "../../../fragments/Tag";

export default function MedPayTags() {
    const activeCase = useSelector(state => state.case.activeCase)
    const [doNotBillTag, setDoNotBillTag] = useState(false)

    useEffect(() => {
        let primaryAtty = isManagingAttorney(activeCase)
        if (activeCase && primaryAtty) {
            if (primaryAtty.law_firm && primaryAtty.law_firm.options) {
                setDoNotBillTag(primaryAtty.law_firm.options.no_med_pay)
            }
        }
    }, [activeCase])

    return <>
        {doNotBillTag ? <Tag>DO NOT BILL</Tag> : ''}
    </>
}